<template>
  <div>
    <v-container>
      <v-card class="page-404">
        <h2 class="mb-8">Page Not Found</h2>

        <div class="page-404__subtitle">This page was not found, <br />please check your link</div>

        <router-link to="/">
          <v-btn class="mt-8" rounded depressed color="secondary" dark>Go to Home Page</v-btn>
        </router-link>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'notfound',
  components: {},
}
</script>

<style lang="scss">

</style>
